<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <div class="vert">

        <div>
            <label for="bpmInput">BPM (reactive)</label>
            <div class="d-flex justify-center">
              <button @click="bpm--">-</button>
              <input v-model="bpm" id="bpmInput" type="number" placeholder="120" />
              <button @click="bpm++">+</button>
            </div>
        </div>
        
        <button @click="playTest()">{{ playing ? 'Pause' : 'Play'}}</button>

        <div>
          <span>Track</span>  
          <select v-model="instrumentTrack">
            <option value="drums">drums</option>
            <option value="base">bass</option> <!-- uses "base" since thats what annyang picks up -->
            <option value="synth">synth</option>
          </select>
          <div>
            Say "change to the X track"
          </div>
        </div>

    </div>
  </div>
</template>

<script>
// import pizzicato from 'pizzicato';
import Tone from 'tone';
import annyang from 'annyang';
// import { analyze } from 'web-audio-beat-detector';

const COMMANDS = {
  recordDrums: 'RECORD DRUMS',
  recordBass: 'RECORD BASS',
  recordMelody: 'RECORD MELODY',
  recordAudio: 'RECORD AUDIO',
};

export default {
  name: 'Looper',
  data() {
    return {
      msg: 'reactivity + voice input playground',
      playing: false,
      command: '',
      bpm: 120,
      loop4: undefined,

      instrumentTrack: 'drums',
    };
  },
  watch: {
    bpm: (newBpm) => {
      Tone.Transport.bpm.value = newBpm;
    },
  },
  methods: {
    processCommand() {
      console.log('processing test command!');
      console.log(this.command);

      if (this.command.toUpperCase().startsWith(COMMANDS.recordDrums)) {
        this.msg = 'record drums command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordBass)) {
        this.msg = 'record bass command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordMelody)) {
        this.msg = 'record melody command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordAudio)) {
        this.msg = 'record AUDIO command';
      } else {
        this.msg = 'unknown command: try record audio, record drums, etc';
      }
      this.command = '';
    },
    playTest() {
      // create a synth and connect it to the master output (your speakers)
      const synth = new Tone.Synth().toMaster();
      const synth2 = new Tone.Synth().toMaster();

      const delay = new Tone.FeedbackDelay('8n', 0.75).toMaster();

      synth.connect(delay);

      // play a middle 'C' for the duration of an 8th note
      // synth.triggerAttackRelease('C3', '8n');

      const loop = new Tone.Loop((time) => {
        synth.triggerAttackRelease('a#2', '8n', time);
      }, '1n');

      const loop2 = new Tone.Loop((time) => {
        synth2.triggerAttackRelease('c#4', '2n', time);
      }, '2n');

      const snareDrum = new Tone.Player(
        '/static/sounds/drums/808/SD0010.WAV',
      ).toMaster();

      const loop3 = new Tone.Loop((time) => {
        // console.log(time);
        snareDrum.start(time);
      }, '2n');


      // eslint-disable-next-line no-unused-vars
      const seq = new Tone.Sequence(((time, step) => {
        // console.log(step); // step
      }), [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], '16n');


      seq.stop();
      seq.start(0);


      loop.start();
      loop2.start();

      loop3.humanize = true;
      loop3.start();

      if (this.playing) {
        this.playing = false;
        Tone.Transport.stop();
      } else {
        this.playing = true;
        Tone.Transport.start();
      }

      // analyze(snareDrum.buffer)
      //   .then((tempo) => {
      //     console.log('analyze from snare is back');
      //     console.log(tempo);
      //   })
      //   .catch((err) => {
      //     console.log('analyze blew up, sad panda.');
      //     console.error(err);
      //   });

      // const freqs = [
      //   3729.31,
      //   3322.438,
      //   2959.955,
      //   2489.016,
      //   2217.461,
      //   1864.655,
      //   1661.219,
      //   1479.978,
      //   1244.508,
      //   1108.731,
      //   932.3275,
      //   932.3275,
      //   739.9888,
      //   622.254,
      //   554.3653,
      //   466.1638,
      //   415.3047,
      //   369.9944,
      //   311.127,
      //   277.1826,
      //   233.0819,
      //   207.6523,
      //   184.9972,
      //   155.5635,
      //   138.5913,
      //   116.5409,
      //   103.8262,
      //   92.49861,
      //   77.78175,
      // ];
      // const val = freqs[Math.floor(Math.random() * freqs.length)];
      // const sawtoothWave = new pizzicato.Sound({
      //   source: 'wave',
      //   options: {
      //     type: 'sawtooth',
      //     frequency: val,
      //   },
      // });
      // const delay = new pizzicato.Effects.Delay({
      //   feedback: 0.8,
      //   time: 0.22,
      //   mix: 0.75,
      // });
      // sawtoothWave.addEffect(delay);
      // sawtoothWave.play();
      // setTimeout(() => {
      //   sawtoothWave.stop();
      // }, 500);
    },
  },
  mounted() {
    console.log('Looper mounted');

    if (annyang) {
      console.log('annyang loaded');
      const commands = {
        'hello world': () => {
          console.log('hello world!');
        },
        'something unique': () => {
          console.log('mo unique mo better?');
        },
        potatoe() {
          console.log('potatoe!');
        },
        'change to the :instrument track': (instrument) => {
          console.log(`change to ${instrument} track`);
          this.instrumentTrack = instrument;
        },
      };
      annyang.addCommands(commands);
      annyang.start();
      // annyang.resume();

      annyang.addCallback('soundstart', (x) => {
        console.log(`sound started! ${x}`);
      });
    } else {
      console.log('no annyang');
    }
  },
  beforeDestroy() {
    annyang.pause();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vert {
    display: flex;
    flex-direction: column;
    max-width: 240px;
    margin: 0 auto;
}
.vert > * {
    margin: 8px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}
</style>



// WEBPACK FOOTER //
// src/components/Loop.vue